import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-footer',
    imports: [],
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss',
})
export class FooterComponent {
    @Input() signature: string = '';
    /** Footer reference code of the end date (E + DDMMYY); the registration contracts pass none and keep E300627. */
    @Input() endCode?: string;
}
